/* ==========================================================================
   pdx — Kaufbereich der Standard-Produktseite
   Progressive Enhancement auf dem bestehenden Flux-Markup:
   - Variantenkacheln mit Preis, Stückpreis und Ersparnis
   - Versandfortschritt inklusive des aktuell gewählten Artikels
   - Sticky-Kaufleiste (Vorbild: kjxr-stickybar der Kuji-Seite)
   Ohne dieses Skript bleibt die Seite voll bedienbar.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__pdxBuyboxInit) return;
  window.__pdxBuyboxInit = true;

  var root = document.documentElement;

  /* ---------------------------------------------------------------- Daten */

  function readConfig() {
    var el = document.querySelector('[data-pdx-config]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  var config = readConfig();
  if (!config) return;

  root.classList.add('pdx-on');

  /* ------------------------------------------------------- Geldformatierung
     Prefix, Suffix und Trennzeichen werden aus zwei von Liquid gerenderten
     Beispielen abgeleitet, damit die Anzeige exakt dem Shop-Format folgt und
     eine Währungsumstellung nichts bricht. */

  var money = (function () {
    var zero = String(config.moneyZero || '€0,00');
    var big = String(config.moneyBig || '€1.234,56');

    var numRe = /[\d., \s]*\d/;
    var zeroNum = zero.match(numRe);
    var bigNum = big.match(numRe);

    var prefix = '';
    var suffix = '';
    if (zeroNum) {
      prefix = zero.slice(0, zeroNum.index);
      suffix = zero.slice(zeroNum.index + zeroNum[0].length);
    }

    var decimalSep = ',';
    var groupSep = '.';
    var decimals = 2;

    if (bigNum) {
      var n = bigNum[0].trim();
      var lastComma = n.lastIndexOf(',');
      var lastDot = n.lastIndexOf('.');
      if (lastComma > lastDot) {
        decimalSep = ',';
        groupSep = '.';
        decimals = n.length - lastComma - 1;
      } else if (lastDot > lastComma) {
        decimalSep = '.';
        groupSep = ',';
        decimals = n.length - lastDot - 1;
      }
      if (decimals > 2) decimals = 2;
    }

    return function (cents) {
      var value = Math.round(Number(cents) || 0) / 100;
      var fixed = Math.abs(value).toFixed(decimals);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, groupSep);
      var out = decimals > 0 ? whole + decimalSep + parts[1] : whole;
      return (value < 0 ? '-' : '') + prefix + out + suffix;
    };
  })();

  /* --------------------------------------------------------- Hilfsfunktionen */

  function mainSection() {
    return document.querySelector('product-info[id^="ProductInfo-"], section[id^="MainProduct-"]') || document;
  }

  /* Achtung: Shopifys Ratenzahlungs-Formular (form.installment) trägt
     ebenfalls action="/cart/add" und steht im Markup vor dem echten
     Kaufformular. Deshalb wird über den Submit-Button identifiziert. */
  function mainForm() {
    var forms = mainSection().querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      if (forms[i].querySelector('.product-form__submit')) return forms[i];
    }
    return null;
  }

  function mainSubmit() {
    var form = mainForm();
    return form ? form.querySelector('.product-form__submit') : null;
  }

  function mainQtyInput() {
    return mainSection().querySelector('.product-form-quantity input[type="number"], .quantity__input, input.quantity-input');
  }

  function currentVariantId() {
    var input = mainSection().querySelector('.product-form input[name="id"], input.product-variant-id');
    return input ? Number(input.value) : config.variants.length === 1 ? config.variants[0].id : null;
  }

  function variantById(id) {
    for (var i = 0; i < config.variants.length; i++) {
      if (config.variants[i].id === Number(id)) return config.variants[i];
    }
    return null;
  }

  function currentQty() {
    var input = mainQtyInput();
    var n = input ? parseInt(input.value, 10) : 1;
    return isNaN(n) || n < 1 ? 1 : n;
  }

  function debounce(fn, wait) {
    var t = null;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, wait);
    };
  }

  /* ------------------------------------------------------- Mengen-Multiplikator
     Aus dem Variantennamen abgeleitet — Produktdaten des Shops taugen nicht
     für strukturierte Felder. Erkennt "(x9)", "x9", "9er", "9x".
     Konservativ: im Zweifel 1, damit nie eine falsche Ersparnis entsteht. */

  function multiplierOf(name) {
    var s = String(name || '');
    var patterns = [/\(\s*x\s*(\d{1,3})\s*\)/i, /\bx\s*(\d{1,3})\b/i, /\b(\d{1,3})\s*(?:er|x)\b/i];
    for (var i = 0; i < patterns.length; i++) {
      var m = s.match(patterns[i]);
      if (m) {
        var n = parseInt(m[1], 10);
        if (n >= 2 && n <= 200) return n;
      }
    }
    return 1;
  }

  /* Basispreis pro Stück: günstigste Variante ohne Multiplikator. */
  var basePrice = (function () {
    var base = null;
    config.variants.forEach(function (v) {
      if (multiplierOf(v.t) !== 1) return;
      if (base === null || v.p < base) base = v.p;
    });
    return base;
  })();

  /* --------------------------------------------------------- Variantenkacheln */

  function decorateVariants() {
    if (config.variants.length < 2) return;

    var labels = mainSection().querySelectorAll('label.variant-buttons');
    Array.prototype.forEach.call(labels, function (label) {
      if (label.querySelector('.pdx-vt-name')) return;

      var input = label.previousElementSibling;
      while (input && input.tagName !== 'INPUT') input = input.previousElementSibling;
      if (!input) return;

      var value = input.value;
      var variant = null;
      for (var i = 0; i < config.variants.length; i++) {
        if (config.variants[i].o.indexOf(value) !== -1) {
          variant = config.variants[i];
          break;
        }
      }
      if (!variant) return;

      var mult = multiplierOf(variant.t);
      var frag = document.createDocumentFragment();

      var name = document.createElement('span');
      name.className = 'pdx-vt-name';
      name.textContent = value;
      frag.appendChild(name);

      var price = document.createElement('span');
      price.className = 'pdx-vt-price';
      price.textContent = money(variant.p);
      frag.appendChild(price);

      if (mult > 1) {
        var unit = document.createElement('span');
        unit.className = 'pdx-vt-unit';
        unit.textContent = money(variant.p / mult) + ' ' + config.perUnitLabel;
        frag.appendChild(unit);

        if (basePrice !== null) {
          var save = basePrice * mult - variant.p;
          /* Nur anzeigen, wenn die Ersparnis positiv und plausibel ist. */
          if (save > 0 && save < basePrice * mult * 0.6) {
            var badge = document.createElement('span');
            badge.className = 'pdx-vt-save';
            badge.textContent = config.saveLabel.replace('%s', money(save));
            frag.appendChild(badge);
          }
        }
      }

      if (!variant.a) {
        var out = document.createElement('span');
        out.className = 'pdx-vt-out';
        out.textContent = config.soldOutLabel;
        frag.appendChild(out);
      }

      label.textContent = '';
      label.appendChild(frag);
      label.classList.add('pdx-vt');
    });
  }

  /* ------------------------------------------------------ Versandfortschritt */

  var shipState = { cart: 0 };

  /* Ob eine Ichiban Kuji im Warenkorb liegt, entscheidet über die
     Einschränkung unter der Leiste (2,00 € Pauschale trotz Freigrenze).
     /cart.js liefert keine Produkt-Tags, die Erkennung kann also nur in
     Liquid stattfinden. Der Warenkorb-Drawer wird bei jeder Änderung von
     Liquid neu gerendert und ist damit die aktuellste Quelle; das
     servergerenderte Attribut der Produktseite dient nur als Rückfall. */
  function cartHasKuji() {
    var drawer = document.querySelector('[data-pdx-ship][data-pdx-mode="cart"]');
    if (drawer) return drawer.getAttribute('data-pdx-kuji') === 'true';
    if (shipState.cart === 0) return false;
    var box = document.querySelector('[data-pdx-ship][data-pdx-mode="product"]');
    return !!box && box.getAttribute('data-pdx-kuji') === 'true';
  }

  function renderShipping() {
    /* Nur die Leiste der Produktseite; die im Warenkorb-Drawer rendert
       Liquid und wird bei jeder Warenkorb-Änderung neu ausgegeben. */
    var box = document.querySelector('[data-pdx-ship][data-pdx-mode="product"]');
    if (!box) return;

    /* Die Schwelle steht ausschließlich in snippets/pdx-ship-bar.liquid. */
    var threshold = Number(box.getAttribute('data-pdx-threshold')) || 0;
    if (threshold <= 0) {
      box.hidden = true;
      return;
    }

    var variant = variantById(currentVariantId());
    var pending = variant ? variant.p * currentQty() : 0;
    var projected = shipState.cart + pending;
    var remaining = threshold - projected;

    var text = box.querySelector('.pdx-ship-text');
    var fill = box.querySelector('.pdx-ship-fill');
    var scale = Math.max(0, Math.min(1, projected / threshold));

    fill.style.transform = 'scaleX(' + scale.toFixed(4) + ')';

    if (remaining <= 0) {
      box.classList.add('is-reached');
      text.textContent = shipState.cart >= threshold ? config.shipReachedCart : config.shipReachedWithItem;
    } else {
      box.classList.remove('is-reached');
      var tpl = shipState.cart > 0 ? config.shipRemainingCart : config.shipRemainingWithItem;
      text.innerHTML = tpl.replace('%s', '<strong>' + money(remaining) + '</strong>');
    }

    var note = box.querySelector('[data-pdx-note]');
    if (note) note.hidden = !cartHasKuji();
  }

  function refreshCart() {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        shipState.cart = cart.total_price || 0;
        renderShipping();
      })
      .catch(function () {
        /* Warenkorb nicht lesbar — Leiste zeigt weiter den Stand ohne Cart. */
        renderShipping();
      });
  }

  /* ------------------------------------------------------ Sticky-Kaufleiste */

  var sticky = {
    el: null,
    priceEl: null,
    subEl: null,
    qtyInput: null,
    cta: null,
    observer: null
  };

  function initSticky() {
    sticky.el = document.querySelector('pdx-sticky-buy');
    if (!sticky.el) return;

    sticky.priceEl = sticky.el.querySelector('[data-pdx-sb-price]');
    sticky.subEl = sticky.el.querySelector('[data-pdx-sb-sub]');
    sticky.qtyInput = sticky.el.querySelector('[data-pdx-sb-qty]');
    sticky.cta = sticky.el.querySelector('[data-pdx-sb-cta]');

    /* Mengen-Stepper spiegelt das Hauptformular. */
    Array.prototype.forEach.call(sticky.el.querySelectorAll('[data-pdx-sb-step]'), function (btn) {
      btn.addEventListener('click', function () {
        var step = Number(btn.getAttribute('data-pdx-sb-step'));
        var next = Math.max(1, (parseInt(sticky.qtyInput.value, 10) || 1) + step);
        sticky.qtyInput.value = next;
        syncQtyToMain(next);
        renderSticky();
        renderShipping();
      });
    });

    sticky.qtyInput.addEventListener('change', function () {
      var next = Math.max(1, parseInt(sticky.qtyInput.value, 10) || 1);
      sticky.qtyInput.value = next;
      syncQtyToMain(next);
      renderSticky();
      renderShipping();
    });

    /* Kein zweiter Warenkorb-Pfad: die Leiste löst den echten Button aus,
       damit Fehlerbehandlung, Drawer und Analytics unverändert greifen. */
    sticky.cta.addEventListener('click', function () {
      var submit = mainSubmit();
      if (!submit || submit.disabled) return;
      sticky.cta.classList.add('is-loading');
      submit.click();
      setTimeout(function () {
        sticky.cta.classList.remove('is-loading');
      }, 1200);
    });

    /* Beobachtet wird der echte Kaufbutton, nicht das ganze Formular: mobil
       liegt er beim Laden bereits unter der Falte, dann soll die Leiste
       sofort da sein. Auf Desktop ist er sichtbar und die Leiste bleibt aus. */
    var target = mainSubmit() || mainForm();
    if (!target || typeof IntersectionObserver === 'undefined') {
      showSticky(false);
      return;
    }

    sticky.observer = new IntersectionObserver(
      function (entries) {
        showSticky(!entries[0].isIntersecting);
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0 }
    );
    sticky.observer.observe(target);
  }

  function showSticky(visible) {
    if (!sticky.el) return;
    sticky.el.classList.toggle('is-visible', visible);
    sticky.el.setAttribute('aria-hidden', visible ? 'false' : 'true');
    /* Platz am Seitenende freihalten, damit die Leiste nichts verdeckt. */
    document.body.style.paddingBottom = visible ? sticky.el.offsetHeight + 'px' : '';
  }

  function syncQtyToMain(value) {
    var input = mainQtyInput();
    if (!input) return;
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function renderSticky() {
    if (!sticky.el) return;

    var variant = variantById(currentVariantId());
    var submit = mainSubmit();
    var qty = sticky.qtyInput ? Math.max(1, parseInt(sticky.qtyInput.value, 10) || 1) : 1;

    if (variant) {
      sticky.priceEl.textContent = money(variant.p);
      var parts = [config.taxNote];
      if (config.variants.length > 1) parts.push(variant.t);
      if (qty > 1) parts.push(qty + ' × = ' + money(variant.p * qty));
      sticky.subEl.textContent = parts.join(' · ');
    }

    if (submit) {
      sticky.cta.disabled = submit.disabled;
      var label = submit.querySelector('span');
      sticky.cta.textContent = label ? label.textContent.trim() : config.addToCartLabel;
    }
  }

  /* ------------------------------------------------------------- Verdrahtung */

  var syncAll = debounce(function () {
    decorateVariants();
    renderSticky();
    renderShipping();
  }, 60);

  function boot() {
    decorateVariants();
    initSticky();

    var main = mainQtyInput();
    if (main && sticky.qtyInput) sticky.qtyInput.value = currentQty();

    renderSticky();
    refreshCart();

    /* Das Theme rendert die Section bei Variantenwechsel neu — danach müssen
       Kacheln und Leiste erneut gesetzt werden. */
    ['variant:change', 'shopify:variant:change', 'shopify:section:load'].forEach(function (evt) {
      document.addEventListener(evt, syncAll);
    });

    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches('input[type="radio"][name^="options"], .quantity__input, input.quantity-input')) {
        syncAll();
      }
    });

    var section = mainSection();
    if (section && section !== document && typeof MutationObserver !== 'undefined') {
      new MutationObserver(syncAll).observe(section, { childList: true, subtree: true });
    }

    /* Warenkorb-Änderungen aus Drawer, Cart-Notification oder Sticky-CTA. */
    ['cart:update', 'cart:refresh', 'cart-drawer:open'].forEach(function (evt) {
      document.addEventListener(evt, refreshCart);
    });
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('.product-form__submit')) {
        setTimeout(refreshCart, 700);
      }
    });

    window.addEventListener('resize', debounce(function () {
      if (sticky.el && sticky.el.classList.contains('is-visible')) {
        document.body.style.paddingBottom = sticky.el.offsetHeight + 'px';
      }
    }, 150));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
